var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialLi01 = function SvgSocialLi01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "social_li-01_svg2__a",
    x1: 20.29,
    x2: 182.29,
    y1: 186.59,
    y2: 10.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M172.73 0H27.27C12.21 0 0 12.21 0 27.27v145.45C0 187.79 12.21 200 27.27 200h145.45c15.06 0 27.27-12.21 27.27-27.27V27.27c0-15.06-12.2-27.27-27.26-27.27M68.18 158.27c0 2.33-1.88 4.22-4.2 4.23H46c-2.33 0-4.22-1.88-4.23-4.2V82.96c0-2.33 1.89-4.23 4.23-4.23h17.97c2.33 0 4.22 1.9 4.22 4.23v75.32h-.01Zm-13.2-86.68c-9.41 0-17.05-7.63-17.05-17.05s7.63-17.05 17.05-17.05 17.05 7.63 17.05 17.05-7.63 17.05-17.05 17.05m107.11 86.98c0 2.14-1.72 3.88-3.86 3.89h-19.34c-2.14 0-3.88-1.72-3.89-3.86v-35.3c0-5.27 1.55-23.09-13.78-23.09-11.87 0-14.3 12.19-14.77 17.67v40.75c0 2.12-1.71 3.86-3.83 3.89H83.96c-2.14 0-3.88-1.73-3.88-3.87v-76c0-2.14 1.72-3.88 3.86-3.89h18.67c2.15 0 3.89 1.74 3.89 3.89v6.57c4.41-6.63 10.94-11.72 24.89-11.72 30.89 0 30.68 28.84 30.68 44.68l.02 36.41z",
    style: {
      fill: "url(#social_li-01_svg2__a)"
    }
  }));
};
export default SvgSocialLi01;